<template>
  <div>
    <v-alert
      v-for="(condition, i) in computeCondition.match"
      :key="i"
      class="py-0 mb-0"
    >
      <v-container>
        <v-row align="center">
          <v-col class="grow">
            <v-row align="center" class="custom-qr">
              <v-col cols="12" md="7" class="d-flex align-center">
                <v-select
                  v-model="condition.operation"
                  :items="operationlist"
                  label="เลือกเงื่อนไข"
                  solo
                  dense
                  color="#0D8EEE"
                  item-value="operation"
                  item-text="text"
                  class="mr-2"
                  :error="condition.errorLabel"
                  :error-messages="condition.errorLabelMsg"
                  @input="CheckNumber(i)"
                  :rules="[$store.getters.TextRule(condition.operation)]"
                  style="max-width: 160px"
                ></v-select>
                <div
                  v-if="
                    condition.operation === '><' || condition.operation === '<>'
                  "
                  class="d-flex"
                >
                  <v-text-field
                    v-model="condition.value_from"
                    type="number"
                    solo
                    dense
                    label="คะแนน"
                    class="mr-2"
                    :error="condition.errorLabel"
                    :error-messages="condition.errorLabelMsg"
                    @input="CheckNumber(i)"
                    :rules="[$store.getters.ScoreRule(condition.value_from)]"
                  >
                  </v-text-field>
                  <v-text-field
                    v-model="condition.value_to"
                    type="number"
                    solo
                    dense
                    label="คะแนน"
                    class="mr-2"
                    :error="condition.errorLabel"
                    :error-messages="condition.errorLabelMsg"
                    @input="CheckNumber(i)"
                    :rules="[$store.getters.ScoreRule(condition.value_to)]"
                  >
                  </v-text-field>
                </div>
                <div v-else>
                  <v-text-field
                    v-model="condition.value"
                    type="number"
                    solo
                    dense
                    label="คะแนน"
                    class="mr-2"
                    :error="condition.errorLabel"
                    :error-messages="condition.errorLabelMsg"
                    @input="CheckNumber(i)"
                    :rules="[$store.getters.ScoreRule(condition.value)]"
                  >
                  </v-text-field>
                </div>
              </v-col>
              <v-col cols="12" md="5" class="d-flex align-center">
                <v-autocomplete
                  v-model="condition.nextQuestionID"
                  :items="Jump"
                  label="เลือกคำถาม"
                  solo
                  dense
                  color="#0D8EEE"
                  item-text="questionLabel"
                  item-value="questionID"
                  :rules="[$store.getters.TextRule(condition.nextQuestionID)]"
                  :menu-props="{
                    closeOnClick: true,
                    closeOnContentClick: true,
                    maxHeight: 200,
                  }"
                >
                  <template #prepend> คำถามต่อไป </template>
                  <template v-slot:item="{ item }">
                    <v-list-item
                      @click="condition.nextQuestionID = item.questionID"
                      style="max-width: 600px"
                    >
                      <v-list-item-title>
                        <v-row no-gutters align="center">
                          <span class="d-flex align-center">
                            {{ item.questionLabel }}
                          </span>
                        </v-row>
                      </v-list-item-title>
                    </v-list-item>
                  </template>
                </v-autocomplete>
              </v-col>
            </v-row>
          </v-col>
          <v-col class="shrink d-flex align-center pt-0 mb-2">
            <v-btn
              color="#DE4F3B"
              v-show="Object.keys(computeCondition.match).length > 1"
              icon
              @click="$delete(computeCondition.match, i), CheckAllNumber()"
              ><v-icon>mdi-close</v-icon></v-btn
            >
          </v-col>
        </v-row>
      </v-container>
    </v-alert>
    <v-row>
      <v-col cols="12" class="d-flex justify-start">
        <v-btn color="#0278ae" dark text @click="AddCompute">
          + เพิ่มเงื่อนไข
        </v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="3"> ไม่ตรงเงื่อนไขใดๆ </v-col>
      <v-col cols="7">
        <v-autocomplete
          v-model="computeCondition.notmatch.nextQuestionID"
          :items="Jump"
          label="เลือกคำถาม"
          solo
          dense
          color="#0D8EEE"
          item-text="questionLabel"
          item-value="questionID"
          :rules="[
            $store.getters.TextRule(computeCondition.notmatch.nextQuestionID),
          ]"
          :menu-props="{
            closeOnClick: true,
            closeOnContentClick: true,
            maxHeight: 200,
          }"
        >
          <template #prepend> คำถามต่อไป </template>
          <template v-slot:item="{ item }">
            <v-list-item
              @click="
                computeCondition.notmatch.nextQuestionID = item.questionID
              "
              style="max-width: 600px"
            >
              <v-list-item-title>
                <v-row no-gutters align="center">
                  <span class="d-flex align-center">
                    {{ item.questionLabel }}
                  </span>
                </v-row>
              </v-list-item-title>
            </v-list-item>
          </template>
        </v-autocomplete>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import _ from "lodash";
export default {
  props: ["compute", "Jump", "computeCondition", "NextQuestion"],
  computed: {
    operationlist() {
      return this.$store.state.operation;
    },
  },
  methods: {
    AddCompute() {
      this.computeCondition.match.push({
        nextQuestionID: this.NextQuestion.questionID,
        operation: "",
        value: 0,
        value_from: 0,
        value_to: 0,
        score: 0,
        errorLabel: false,
        errorLabelMsg: "",
      });
    },
    CheckAllNumber() {
      this.computeCondition.match.map((item) => {
        item.computetext = `${item.operation}|${
          item.operation === "><" || item.operation === "<>"
            ? `${item.value_from}|${item.value_to}`
            : item.value
        }`;
        item.errorLabel = false;
        item.errorLabelMsg = "";
      });
      const counts = _.countBy(this.computeCondition.match, "computetext");
      let dup = _.filter(
        this.computeCondition.match,
        (x) => counts[x.computetext] > 1
      );
      if (dup.length > 1) {
        dup.map((item) => {
          if (item.computetext) {
            item.errorLabel = true;
            item.errorLabelMsg = "มีการตั้งเงื่อนไขนี้แล้ว";
          }
        });
      }
    },
    CheckNumber: _.debounce(function() {
      this.computeCondition.match.map((item) => {
        item.computetext = `${item.operation}|${
          item.operation === "><" || item.operation === "<>"
            ? `${item.value_from}|${item.value_to}`
            : item.value
        }`;
        item.errorLabel = false;
        item.errorLabelMsg = "";
      });
      const counts = _.countBy(this.computeCondition.match, "computetext");
      let dup = _.filter(
        this.computeCondition.match,
        (x) => counts[x.computetext] > 1
      );
      if (dup.length > 1) {
        dup.map((item) => {
          if (item.computetext && item.operation) {
            item.errorLabel = true;
            item.errorLabelMsg = "มีการตั้งเงื่อนไขนี้แล้ว";
          }
        });
      }
    }, 0),
  },
};
</script>

<style scoped>
.custom-qr >>> .v-messages__message {
  margin-top: 3px;
}
</style>
